<template>
    <navbar position="fixed"
            :transparent="transparent"
            :color-on-scroll="colorOnScroll"
            menu-classes="ml-auto">
        <template slot-scope="{toggle, isToggled}">
                <!-- <router-link v-popover:popover1 class="navbar-brand" to="/presentation"> -->
                <router-link class="navbar-brand" to="/">
                    <!-- <img src='img/etcPrimary.png' style="width:115px;filter: drop-shadow(0px 0px 5px rgba(0,0,0,.5));" alt="ETC"/> -->
                    <img src='img/etcPrimary.png' style="width:115px;" alt="ETC"/>
                    <div>Electronic Technologies Corp</div>
                </router-link>
                <!-- <el-popover
                        ref="popover1"
                        popper-class="popover"
                        placement="bottom"
                        width="200"
                        trigger="hover">
                    <div class="popover-body">Designed by Invision. Coded by Creative Tim</div>
                </el-popover> -->
        </template>
        <template slot="navbar-menu">
            <li class="nav-item">
                <nav-link to="/facility-refrigeration-controls" class="nav-link" style="color:white;">
                    <p>Controls</p>
                </nav-link>
            </li>
            <li class="nav-item">
                <a href="https://gamsplus.com" target="_blank" class="nav-link" style="color:white;">
                    <p>Monitoring</p>
                </a>
            </li>
            <li class="nav-item">
                <nav-link to="/facility-refrigeration-engineering" class="nav-link" style="color:white;">
                    <p>Engineering</p>
                </nav-link>
            </li>
            <li class="nav-item">
                <a href="https://parts.electronictechcorp.com/" class="nav-link" style="color:white;">
                    <p>Parts</p>
                </a>
            </li>
            <li class="nav-item" v-if="$route.query.admin == 'ETCa'">
                <nav-link to="/article/add" class="nav-link btn-danger" style="color:white;">
                    <p>Add Article</p>
                </nav-link>
            </li>
            <!-- <drop-down tag="li" title="Controls" icon="now-ui-icons design_app" class="nav-item">
                <nav-link to="/components">
                    <i class="now-ui-icons business_chart-pie-36"></i> Components
                </nav-link>
                <a href="https://demos.creative-tim.com/vue-now-ui-kit-pro/documentation" target="_blank" class="dropdown-item">
                    <i class="now-ui-icons design_bullet-list-67"></i> Documentation
                </a>
            </drop-down>
            <drop-down tag="li" title="Monitoring" icon="now-ui-icons files_paper" class="nav-item">
                <nav-link class="dropdown-item" to="/sections#headers">
                    <i class="now-ui-icons shopping_box"></i> Headers
                </nav-link>
                <nav-link class="dropdown-item" to="/sections#features">
                    <i class="now-ui-icons ui-2_settings-90"></i> Features
                </nav-link>
                <nav-link class="dropdown-item" to="/sections#blogs">
                    <i class="now-ui-icons text_align-left"></i> Blogs
                </nav-link>
                <nav-link class="dropdown-item" to="/sections#teams">
                    <i class="now-ui-icons sport_user-run"></i> Teams
                </nav-link>
                <nav-link class="dropdown-item" to="/sections#projects">
                    <i class="now-ui-icons education_paper"></i> Projects
                </nav-link>
                <nav-link class="dropdown-item" to="/sections#pricing">
                    <i class="now-ui-icons business_money-coins"></i> Pricing
                </nav-link>
                <nav-link class="dropdown-item" to="/sections#testimonials">
                    <i class="now-ui-icons ui-2_chat-round"></i> Testimonials
                </nav-link>
                <nav-link class="dropdown-item" to="/sections#contactus">
                    <i class="now-ui-icons tech_mobile"></i> Contact Us
                </nav-link>
            </drop-down>

            <drop-down tag="li" title="Engineering" icon="now-ui-icons design_image" class="nav-item">
                <nav-link to="/about">
                    <i class="now-ui-icons business_bulb-63"></i> About-us
                </nav-link>
                <nav-link to="/blog-post">
                    <i class="now-ui-icons text_align-left"></i> Blog Post
                </nav-link>
                <nav-link class="dropdown-item" to="/blog-posts">
                    <i class="now-ui-icons design_bullet-list-67"></i> Blog Posts
                </nav-link>
                <nav-link class="dropdown-item" to="/contact">
                    <i class="now-ui-icons location_pin"></i> Contact Us
                </nav-link>
                <nav-link class="dropdown-item" to="/landing">
                    <i class="now-ui-icons education_paper"></i> Landing Page
                </nav-link>
                <nav-link class="dropdown-item" to="/login">
                    <i class="now-ui-icons users_circle-08"></i> Login Page
                </nav-link>
                <nav-link class="dropdown-item" to="/pricing">
                    <i class="now-ui-icons business_money-coins"></i> Pricing
                </nav-link>
                <nav-link class="dropdown-item" to="/ecommerce">
                    <i class="now-ui-icons shopping_shop"></i> Ecommerce Page
                </nav-link>
                <nav-link class="dropdown-item" to="/product">
                    <i class="now-ui-icons shopping_bag-16"></i> Product Page
                </nav-link>
                <nav-link class="dropdown-item" to="/profile">
                    <i class="now-ui-icons users_single-02"></i> Profile Page
                </nav-link>
                <nav-link class="dropdown-item" to="/signup">
                    <i class="now-ui-icons tech_mobile"></i> Signup Page
                </nav-link>
            </drop-down> -->
            <!-- <li class="nav-item">
                <a class="nav-link btn btn-primary"
                   href="https://www.creative-tim.com/product/vue-now-ui-kit-pro" target="_blank">
                    <p>Buy Now</p>
                </a>
            </li> -->
        </template>
    </navbar>
</template>

<script>
  import { DropDown, NavbarToggleButton, Navbar, NavLink } from '@/components';
  import { Popover } from 'element-ui'
  export default {
    name: 'main-navbar',
    props: {
      transparent: Boolean,
      colorOnScroll: Number,
    },
    components: {
      DropDown,
      Navbar,
      NavbarToggleButton,
      NavLink,
      [Popover.name]: Popover
    }
  }
</script>

<style scoped>
.navbar-brand div{
    float:right;
    padding-left:10px;
    padding-top: 1px;
}
@media screen and (max-width: 500px){
    
    .navbar-brand div{
        float: right;
        padding-left: 10px;
        width: 200px;
        white-space: normal;
        line-height: 1.1;
    }
}
@media screen and (max-width: 420px){
    .navbar-brand div{
        float:right;
        padding-left: 0px;
            width: 120px;
    font-size: .8571em;
    padding-top: 4px;
    line-height: 1.1em;
    }
    
}
</style>
